import React, { FC, useEffect, useRef } from 'react'
import _ from 'lodash'
import Skeleton from '@material-ui/lab/Skeleton';
import { joinPaths } from "src/common/razzle-platform-components/utils"
import { useIntl } from 'src/common/razzle-platform-translate'
import { BookmarkOfProduct } from "src/common/razzle-platform-bookmarkofproduct/BookmarkOfProduct"
import { RatingSarts } from 'src/modules/components/RatingSarts';
import { Product } from 'declarations'
import { BASE_URL, NUMBER_OF_BEDS_UUID, CERTIFIED_VEHICLE_TAG_UUID } from 'src/configs'
import { makeStyles } from '@material-ui/core/styles';
import MiniSwiper from 'src/common/razzle-platform-map/components/product/MiniSwiper';

export type ProductItemProps = {
    item: Product
}


export const ProductItemSkeleton: FC<any> = () => {

	return (
		<React.Fragment>
			<section className="elementor-section elementor-inner-section elementor-element elementor-element-ff372e1 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="ff372e1" data-element_type="section">
				<div className="elementor-container elementor-column-gap-default">
					<div className="elementor-row">
						<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-f8f66e1" data-id="f8f66e1" data-element_type="column">
							<div className="elementor-column-wrap elementor-element-populated">
								<div className="elementor-widget-wrap">
									<div className="elementor-element elementor-element-65f912c elementor-widget elementor-widget-image" data-id="65f912c" data-element_type="widget" data-widget_type="image.default">
										<div className="elementor-widget-container">
											<div className="elementor-image">
												<a href="#">
													<Skeleton animation="wave" variant="rect" height="198px" width="300px" />
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-4f131ba" data-id="4f131ba" data-element_type="column">
							<div className="elementor-column-wrap elementor-element-populated">
								<div className="elementor-widget-wrap">
									<section className="elementor-section elementor-inner-section elementor-element elementor-element-3c4c862 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="3c4c862" data-element_type="section">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-row">
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d5e14d4" data-id="d5e14d4" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated">
														<div className="elementor-widget-wrap">
															<div className="elementor-element elementor-element-29dc058 elementor-widget elementor-widget-heading" data-id="29dc058" data-element_type="widget" data-widget_type="heading.default">
																<div className="elementor-widget-container">
																	<h2 className="elementor-heading-title elementor-size-medium">
																		<Skeleton animation="wave" width="85%" height="36px" variant="text" />
																	</h2>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-550dd35" data-id="550dd35" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated">
														<div className="elementor-widget-wrap">
															<div className="elementor-element elementor-element-3ced268 elementor-view-default elementor-widget elementor-widget-icon" data-id="3ced268" data-element_type="widget" data-widget_type="icon.default">
																<div className="elementor-widget-container">
																	<div className="elementor-icon-wrapper">
																		<div className="elementor-icon elementor-animation-shrink">
																			<Skeleton animation="wave" variant="circle" width={30} height={30} />
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
									<section className="elementor-section elementor-inner-section elementor-element elementor-element-ed18050 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="ed18050" data-element_type="section">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-row">
												<div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-2dd693f" data-id="2dd693f" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated">
														<div className="elementor-widget-wrap">
															<div className="elementor-element elementor-element-4cc39f1 elementor-widget elementor-widget-text-editor" data-id="4cc39f1" data-element_type="widget" data-widget_type="text-editor.default">
																<div className="elementor-widget-container">
																	<div className="elementor-text-editor elementor-clearfix">
																		<p>
																			<Skeleton animation="wave" variant="text" width="40%" />
																			<Skeleton animation="wave" variant="text" width="50%" />
																			<Skeleton animation="wave" variant="text" width="43%" />
																		</p>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
									<section className="elementor-section elementor-inner-section elementor-element elementor-element-08dd60d elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="08dd60d" data-element_type="section">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-row">
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-e7d4b54" data-id="e7d4b54" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated">
														<div className="elementor-widget-wrap">
															<Skeleton animation="wave" variant="text" width="70%" />
														</div>
													</div>
												</div>
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-c1974f7" data-id="c1974f7" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated">
														<div className="elementor-widget-wrap">
															<div className="elementor-element elementor-element-5142721 elementor-widget elementor-widget-heading" data-id={5142721} data-element_type="widget" data-widget_type="heading.default">
																<div className="elementor-widget-container">
																	<h2 className="elementor-heading-title elementor-size-medium"></h2>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<div className="elementor-element elementor-element-4a06f94 elementor-widget-divider--view-line elementor-widget elementor-widget-divider" data-id="4a06f94" data-element_type="widget" data-widget_type="divider.default">
				<div className="elementor-widget-container">
					<div className="elementor-divider">
						<span className="elementor-divider-separator">
						</span>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

const useStyles = makeStyles({
    parent: {
        '&:hover': {
            '& .slider-container button': {
                display: 'block',
            },
        },
        '& .image-slider-wrapper': {
            width: '50%',
				height: '220px',
				padding: '10px',
				maxWidth: '320px',
				borderRadius: '10px',
				'@media (max-width: 767px)': {
					maxWidth: 'none',
					width: '100%',
				},
        },
        '& .bookmark': {
            position: 'relative',
            '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '38px',
                height: '38px',
                borderRadius: '50%',
            },
            '&:hover': {
                transform: 'scale(1.2)',
            },
            '&:hover::before': {
                backgroundColor: 'rgb(247, 247, 247)',
            },
            '& button': {
                padding: 0,
					 margin: '0 !important' ,
            },
        },
        '& .content-wrap': {
            alignContent: 'flex-start',
            flexDirection: 'column',
            marginBottom: '-4px',
            '& .elementor-element-ed18050': {
                flexGrow: 1,
            },
        },
        '& .price': {
            fontSize: '16px !important',
            ' & span': {
                fontSize: '18px',
            },
        },
    },
})


export const ProductItem: FC<ProductItemProps> = (props) => {
    const { item: product } = props
    const { formatMessage } = useIntl()
	 const classes = useStyles()

    const numberOfBedsSpecificity = _.head(_.filter(product.productSpecificities, e => (e.uuid === NUMBER_OF_BEDS_UUID)))
	const shouldShowCertifiedVehicleTag=product?.tags?.some((tag)=>tag.uuid===CERTIFIED_VEHICLE_TAG_UUID)

    return (
		<React.Fragment>
			<section className={"elementor-section elementor-inner-section elementor-element elementor-element-ff372e1 elementor-section-boxed elementor-section-height-default elementor-section-height-default " + classes.parent} data-id="ff372e1" data-element_type="section">
				<div className="elementor-container elementor-column-gap-default">
					<div className="elementor-row">
					<div className="image-slider-wrapper">
						{shouldShowCertifiedVehicleTag && 
							<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-f8f66e1" data-id="f8f66e1" data-element_type="column">
								<div className="elementor-column-wrap elementor-element-populated">
									<div className="elementor-widget-wrap">
										<div className="elementor-element elementor-element-5e59121 elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="5e59121" data-element_type="widget" data-widget_type="heading.default">
											<div className="elementor-widget-container">
												<div className="elementor-heading-title elementor-size-default">
													{ formatMessage({ id: 'Certifié', defaultMessage: 'Certifié' }) }									
												</div>		
											</div>
										</div>
									</div>
								</div>
							</div> }
								<MiniSwiper images={product.images} alt={product.name} />	
						</div>	
							
						<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-4f131ba" data-id="4f131ba" data-element_type="column">
							<div className="elementor-column-wrap elementor-element-populated px-0">
								<div className="elementor-widget-wrap content-wrap">
									<section className="elementor-section elementor-inner-section elementor-element elementor-element-3c4c862 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="3c4c862" data-element_type="section">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-row">
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d5e14d4" data-id="d5e14d4" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated">
														<div className="elementor-widget-wrap">
															<div className="elementor-element elementor-element-29dc058 elementor-widget elementor-widget-heading" data-id="29dc058" data-element_type="widget" data-widget_type="heading.default">
																<div className="elementor-widget-container">
																	<h2 className="elementor-heading-title elementor-size-medium">{product.name}</h2>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-550dd35" data-id="550dd35" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated" style={{ padding: '10px 0 0 0' }}>
														<div className="elementor-widget-wrap">
															<div className="elementor-element elementor-element-3ced268 elementor-view-default elementor-widget elementor-widget-icon" data-id="3ced268" data-element_type="widget" data-widget_type="icon.default">
																<div className="elementor-widget-container" style={{ paddingRight: '10px' }}>
																	<div className="elementor-icon-wrapper">
																		<div className="elementor-icon elementor-animation-shrink bookmark">
																			<BookmarkOfProduct productId={product.id} />
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
									<section className="elementor-section elementor-inner-section elementor-element elementor-element-ed18050 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="ed18050" data-element_type="section">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-row">
												<div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-2dd693f" data-id="2dd693f" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated">
														<div className="elementor-widget-wrap">
															<div className="elementor-element elementor-element-4cc39f1 elementor-widget elementor-widget-text-editor" data-id="4cc39f1" data-element_type="widget" data-widget_type="text-editor.default">
																<div className="elementor-widget-container">
																	<div className="elementor-text-editor elementor-clearfix">
																		<p style={{ margin: 0, fontSize: '16px' }}>{product.address && <>{product.address.country} | {product.address.city}</>} <br />
																			{product.category && product.category.name} <br />
																			<span style={{ color: 'var( --e-global-color-text )' }}>{numberOfBedsSpecificity && `${numberOfBedsSpecificity.name}: ${_.find(numberOfBedsSpecificity.choices, { value: numberOfBedsSpecificity.choice })?.label}`}</span>
																		</p>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
									<section className="elementor-section elementor-inner-section elementor-element elementor-element-08dd60d elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="08dd60d" data-element_type="section">
										<div className="elementor-container elementor-column-gap-default">
											<div className="elementor-row">
												{product.reviewScore > 0 && <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-e7d4b54" data-id="e7d4b54" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated py-0">
														<div className="elementor-widget-wrap">
															<div className="elementor-element elementor-element-9e78cae elementor-star-rating--align-left elementor--star-style-star_fontawesome elementor-widget elementor-widget-star-rating" data-id="9e78cae" data-element_type="widget" data-widget_type="star-rating.default">
																<div className="elementor-widget-container">
																	<div className="elementor-star-rating__wrapper">
																		<div className="elementor-star-rating__title">({product.reviewsNumber})</div>
																		<div className="elementor-star-rating" title={`${product.reviewScore}/5`} itemType="http://schema.org/Rating" itemScope itemProp="reviewRating">
                                                                            <RatingSarts rating={product.reviewScore} />
																			<span itemProp="ratingValue" className="elementor-screen-only">{product.reviewScore}/5</span>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>}
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-c1974f7" data-id="c1974f7" data-element_type="column">
													<div className="elementor-column-wrap elementor-element-populated py-0">
														<div className="elementor-widget-wrap content-end">
															<div className="elementor-element elementor-element-5142721 elementor-widget elementor-widget-heading" data-id={5142721} data-element_type="widget" data-widget_type="heading.default">
																<div className="elementor-widget-container">
																	<h2 className="elementor-heading-title elementor-size-medium price"><span>{product.price}</span> { formatMessage({ id: 'RP/jour', defaultMessage: 'RP/jour' }) }</h2>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</section>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<div className="elementor-element elementor-element-4a06f94 elementor-widget-divider--view-line elementor-widget elementor-widget-divider" data-id="4a06f94" data-element_type="widget" data-widget_type="divider.default">
				<div className="elementor-widget-container">
					<div className="elementor-divider">
						<span className="elementor-divider-separator">
						</span>
					</div>
				</div>
			</div>
		</React.Fragment>
	)

}
